import { useEffect } from 'react';

import { useAuthentication } from '@givebacks/api';
import { useShowBackerInfo } from '@givebacks/api/backer';
import { useBreakPoints } from 'core';
import { useNavigate } from 'react-router-dom';
import { HowToGivebackCard, SimpleGrid, Stack, Title } from 'ui';

const HowToGivebackCards = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthentication();
  const { data: backer, refetch: refetchBacker } = useShowBackerInfo();

  // we want to fetch backer data as soon as a user logs in
  // Adding 'enabled' to the useShowBackerInfo hook should allow this to update when the user logs ins
  useEffect(() => {
    isAuthenticated && refetchBacker();
  }, [isAuthenticated, refetchBacker]);

  return (
    <SimpleGrid cols={{ base: 3, sm: 5 }} verticalSpacing="sm">
      <HowToGivebackCard
        type="purchases"
        onClick={() => navigate('buy')}
        completed={backer?.home?.buy_via_consumer}
      />
      <HowToGivebackCard
        type="online"
        onClick={() => navigate('online')}
        completed={backer?.home?.earned_online}
      />
      <HowToGivebackCard
        type="dining"
        onClick={() => navigate('dine')}
        completed={backer?.home?.earned_dining}
      />
    </SimpleGrid>
  );
};

const HowToGiveback = () => {
  const { isSmallScreen } = useBreakPoints();
  return (
    <Stack gap={isSmallScreen ? 'md' : 'lg'}>
      <Title order={2}>How to Giveback</Title>
      <HowToGivebackCards />
    </Stack>
  );
};

export { HowToGiveback };
